import { CardTitle as l } from "../../Card/Title/CardTitle.js";
const r = l;
export {
  r as CollapsibleCardTitle
};
